module.exports = __webpack_public_path__ + "static/media/bg2.c63fd287.jpg";